<template>
    <b-container>
        <b-row align-h="start">
            <b-col cols="auto">
                <b-btn size="sm" variant="primary" @click="$router.go(-1)">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </b-btn>
            </b-col>
            <b-col>
                <app-sub-title :text="processName"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                cols="12"
                md="4"
                v-for="type in documentTypes"
                :key="type.id"
                class="mb-2"
            >
                <b-card @click="openType(type)" class="folder">
                    <b-card-text>
                        <b-row align-v="center">
                            <b-col cols="auto">
                                <i
                                    class="fa fa-folder-o fa-3x folder-icon"
                                    aria-hidden="true"
                                ></i>
                            </b-col>
                            <b-col>
                                {{ type.name }}
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        documentTypes: [],
        processId: '',
        processName: '',
    }),
    computed: {},
    methods: {
        async loadDocumentTypes() {
            const { data } = await repo.get('quality/document-types')
            this.documentTypes = data
        },
        validateParams() {
            if (!('p' in this.$route.query))
                return this.$router.push({ name: 'quality' })

            const payload = JSON.parse(atob(this.$route.query.p))
            if (!('processId' in payload) || !('processName' in payload))
                this.$router.push({ name: 'quality' })

            this.processId = payload.processId
            this.processName = payload.processName
        },
        openType(type) {
            const payload = btoa(
                JSON.stringify({
                    processId: this.processId,
                    processName: this.processName,
                    typeId: type.id,
                    typeName: type.name,
                })
            )

            this.$router.push({
                name: 'qualityDocuments',
                query: {
                    p: payload,
                },
            })
        },
    },
    created() {
        this.validateParams()
        this.loadDocumentTypes()
    },
}
</script>
<style scoped>
.folder {
    cursor: pointer;
}
.folder-icon {
    color: #ff761c;
}
</style>
